module.exports={
    "no": {
        "weFound": "Vi fant",
        "result": "treff",
        "results": "treff",
        "forYourSearch": "til søket ditt",
        "waybillNumber": "Fraktbrevnummer",
        "orderId": "Ordrenr.",
        "etd": "ETD",
        "eta": "ETA",
        "arrivalAtd": "Ankomst overtakelse",
        "arrivalAta": "Ankomst levering",
        "weight": "Vekt",
        "showInMap": "Vis i kart",
        "showSignature": "Vis signatur",
        "externalEvent": "Ekstern hendelse",
        "pallets": "Paller",
        "goodsType": "Godstype",
        "volume": "Volum",
        "awbReference": "Flyfraktnummer",
        "billOfLadingReference": "Konnossementsnummer",
        "containerNumberReference": "Containernummer",
        "sendersRef": "Senders ref.",
        "poRef": "Po ref.",
        "packages": "Pakker",
        "loadingMetres": "Lastemeter",
        "customersRef": "Kundens ref.",
        "orderInformation": "Ordreinformasjon",
        "consignor": "Avsender",
        "consignee": "Mottaker",
        "deliveryParty": "Leveringsadresse",
        "grossWeight": "Bruttovekt",
        "documents": "Dokumenter",
        "publicPicture": "Bilde",
        "waybill": "Fraktbrev",
        "unknownDocument": "Ukjent dokument",
        "pickUpEvent": "Hent",
        "pickedUpEvent": "Hentet",
        "pickUpAtEvent": "Hent hos",
        "pickedUpAtEvent": "Hentet hos",
        "loadEvent": "Last hos",
        "loadedEvent": "Lastet hos",
        "unloadEvent": "Loss hos",
        "unloadedEvent": "Losset hos",
        "deliverEvent": "Lever",
        "deliverToEvent": "Lever til",
        "deliveredEvent": "Levert",
        "deliveredToEvent": "Levert til",
        "customsError": "Fortolling, feilmelding fra Toll / TVINN",
        "customsReceipt": "Fortollet, tollkvittering: ",
        "customsDisclosureCertificate": "Fortollet, utleveringsattest: ",
        "customsMessage": "Fortolling, melding mottatt fra toller",
        "signatures": "Signaturer",
        "packageEvents": "Pakke-hendelser",
        "packageLAEvent": "Last",
        "packageLOEvent": "Loss",
        "packageLEVEvent": "Loss",
        "packageLAActualEvent": "Lastet",
        "packageLOActualEvent": "Losset",
        "packageLEVActualEvent": "Losset",
        "packageMANKO_LAEvent": "Pakker manglet ved lasting",
        "packageMANKO_LOEvent": "Pakker manglet ved lossing",
        "packageMANKO_LAActualEvent": "Pakker manglet ved lasting",
        "packageMANKO_LOActualEvent": "Pakker manglet ved lossing",
        "missing": "Manko",
        "noEvents": "Ingen hendelser registrert",
        "freeText": "Annen info",
        "packagegoodsItemDescription" : "Varebeskrivelse"
    },

    "en": {
        "weFound": "We found",
        "result": "result",
        "results": "results",
        "forYourSearch": "for your search",
        "waybillNumber": "Waybill Number",
        "orderId": "Order Id",
        "etd": "ETD",
        "arrivalAtd": "Arrival ATD",
        "arrivalAta": "Arrival ATA",
        "eta": "ETA",
        "weight": "Weight",
        "showInMap": "Show In Map",
        "showSignature": "Show Signature",
        "externalEvent": "External Event",
        "pallets": "Pallets",
        "goodsType": "Goods Type",
        "volume": "Volume",
        "awbReference": "Air Waybill Number",
        "billOfLadingReference": "Bill of Lading Number",
        "containerNumberReference": "Container Number",
        "sendersRef": "Senders Ref",
        "poRef": "Po Ref",
        "packages": "Packages",
        "loadingMetres": "Loading Metres",
        "customersRef": "Customers Ref",
        "orderInformation": "Order Information",
        "consignor": "Consignor",
        "consignee": "Consignee",
        "deliveryParty": "Deliver To",
        "grossWeight": "Gross Weight",
        "documents": "Documents",
        "publicPicture": "Public Picture",
        "waybill": "Waybill",
        "unknownDocument": "Unknown Document",
        "pickUpEvent": "Pick Up",
        "pickedUpEvent": "Picked Up",
        "pickUpAtEvent": "Pick Up At",
        "pickedUpAtEvent": "Picked Up At",
        "loadEvent": "Load At",
        "loadedEvent": "Loaded At",
        "unloadEvent": "Unload At",
        "unloadedEvent": "Unloaded At",
        "deliverEvent": "Deliver",
        "deliverToEvent": "Deliver To",
        "deliveredEvent": "Delivered",
        "deliveredToEvent": "Delivered To",
        "customsError": "Customs Clearance: Error message from Customs / TVINN",
        "customsReceipt": "Customs Cleared: Receipt ",
        "customsDisclosureCertificate": "Customs Cleared: Disclosure certificate ",
        "customsMessage": "Customs Clearance: Message received from customs officer",
        "signatures": "Signatures",
        "packageEvents": "Package Events",
        "packageLAEvent": "Load",
        "packageLOEvent": "Unload",
        "packageLEVEvent": "Unload",
        "packageLAActualEvent": "Loaded",
        "packageLOActualEvent": "Unloaded",
        "packageLEVActualEvent": "Unloaded",
        "packageMANKO_LAEvent": "Packages missing when loading",
        "packageMANKO_LOEvent": "Packages missing when unloading",
        "packageMANKO_LAActualEvent": "Packages missing when loading",
        "packageMANKO_LOActualEvent": "Packages missing when unloading",
        "missing": "Missing",
        "noEvents": "No registered events",
        "freeText": "Other information",
        "packagegoodsItemDescription" : "Goods item description"
    }
}
